var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from "@mui/material";
import CustomColorPicker from "./CustomColorPicker";
export default function ColorPicker(_a) {
    var color = _a.color, setColor = _a.setColor, _b = _a.legend, legend = _b === void 0 ? '' : _b;
    return (_jsxs(Box, { children: [_jsx(Typography, __assign({ variant: "subtitle1", fontWeight: "bold" }, { children: "Color de fondo" })), _jsx(Typography, __assign({ variant: "body2", color: "textSecondary" }, { children: legend || 'Selecciona un color para el fondo de la tarjeta.' })), _jsxs("div", __assign({ style: { display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 8, justifyContent: 'center', width: '100%' } }, { children: [_jsx("div", { style: { backgroundColor: color, width: 50, height: 50, border: '1px solid #ccc', borderRadius: 2 } }), _jsx(CustomColorPicker, { value: color, onChange: function (newColor) { return setColor(newColor); } })] }))] }));
}
